import { ADD_APPLIANCE, DELETE_APPLIANCE, EDIT_APPLIANCE, CLEAR, UPDATE_APPLIANCE } from "./actionTypes";

export const addAppliance = appliance => ({
  type: ADD_APPLIANCE,
  payload: {
    appliance
  }
});

export const deleteAppliance = applianceId => ({
  type: DELETE_APPLIANCE,
  payload: {
    applianceId
  }
});

export const editAppliance = applianceId => ({
  type: EDIT_APPLIANCE,
  payload: {
    applianceId
  }
});

export const updateAppliance = (applianceId, appliance) => ({
  type: UPDATE_APPLIANCE,
  payload: {
    applianceId, appliance
  }
});

export const clear = () => ({
  type: CLEAR
});